import validateUuid from 'uuid-validate';

export default function parseUuid(uuid: string | (string | null)[] | null | undefined): string | null {
	if (Array.isArray(uuid)) {
		return uuid[0] || '';
	}

	return uuid && validateUuid(uuid) ? uuid : null;
}
